import { readCookie } from 'components/Utils';

class Segment {
  constructor() {
    if (this.shouldTrack()) {
      window.analytics.ready(() => {
        this.anonId = window.mixpanel.get_distinct_id();
      });
    }
  }

  shouldTrack() {
    return (
      window.analytics &&
      process.env.NODE_ENV === 'production' &&
      !readCookie('logged_in_as_admin')
    );
  }

  page() {
    if (this.shouldTrack()) window.analytics.page();
  }

  alias(id) {
    if (this.shouldTrack()) window.analytics.alias(id);
  }

  identify(id, data) {
    if (this.shouldTrack()) window.analytics.identify(id, data);
  }

  track(evt, data) {
    if (this.shouldTrack()) {
      window.analytics.track(evt, data);
    }
  }

  trackLink(el, evt, data) {
    if (this.shouldTrack()) {
      window.analytics.trackLink(el, evt, data);
    }
  }
}

export default Segment;



// WEBPACK FOOTER //
// ./src/components/Segment/index.js